import { axios } from '@/util/axios.js';
const baseUrl = '/api'

function handlerPaging(params={}){
    let {page,limit} = params;
    let pn = parseInt(page),ps = parseInt(limit);
    if(isNaN(pn) || pn < 0 ){
      pn = 1;
    }
    if(isNaN(ps) || ps < 1 ){
      ps = 10;
    }
    return Object.assign(params,{page:pn,limit:ps})
}

/* 公司级事件列表 */
export function customerEventList(params = {}, callback) {
    handlerPaging(params.data);
    return axios.request({
      "url" : baseUrl+'/customers/'+params.customer_id+"/event_info/",
        "method": "get",
        "params": params.data
    },callback)
}

/* 站点级事件列表 */
export function siteEventList(params = {}, callback) {
    handlerPaging(params.data);
    return axios.request({
      "url" : baseUrl+'/sites/'+params.site_id+"/event_info/",
        "method": "get",
        "params": params.data
    },callback)
}

/* 设备级事件列表 */
export function equipmentEventList(params = {}, callback) {
    handlerPaging(params.data);
    return axios.request({
      "url" : baseUrl+'/equipments/'+params.equipment_id+"/event_info/",
        "method": "get",
        "params": params.data
    },callback)
}

/* 事件详情 */
export function getEventDetail(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/events/'+params.event_id+"/",
      "method": "get",
    },callback)
}

/* 公司级事件导出 */
export function exportEventData(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/customers/'+params.customer_id+"/event_export/",
      "method": "post",
      "data": params.data,
      "responseType": 'blob'
    },callback)
}


// WEBPACK FOOTER //
// ./src/data/event.js